import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const CLASS_OPTION_NOVALUE = "is-option-no-value";
const CLASS_OPTION_SELECTED = "is-option-selected";

export default class DropdownOption extends Component {
    static propTypes = {
        label: PropTypes.string,
        value: PropTypes.string,
        selected: PropTypes.bool,
        onClick: PropTypes.func
    };

    handleClick = () => {
        const { onClick, value } = this.props;

        if (onClick) {
            onClick(value);
        }
    };

    render() {
        const { label, value, selected } = this.props;

        return (
            <li
                className={classNames({
                    [CLASS_OPTION_NOVALUE]: !value,
                    [CLASS_OPTION_SELECTED]: selected
                })}
                onClick={this.handleClick}
            >
                {label}
            </li>
        );
    }
}



// WEBPACK FOOTER //
// ./public/assets/scripts/components/DropdownOption.js